import { DateFormat } from '@agroone/dates'

import { IsDateValidate } from '@agroone/helpers'
import { IsInt, IsOptional, IsString } from 'class-validator'

export class SetHarvestDateDto {
  @IsString()
  @IsDateValidate(DateFormat.YYYY_MM_DD)
  yesterdayDate!: string

  @IsInt()
  @IsOptional()
  replacingOfferId?: number
}
